<ng-container *ngIf="!isReadOnly; else disabledInput">
  <app-form-control-textarea
    [label]="label"
    [labelExtraInfo]="labelExtraInfo"
    [id]="id"
    [name]="id"
    [formSubmitted]="formSubmitted"
    [placeholder]="placeholder"
    [showLabel]="showLabel"
    [showErrors]="showErrors"
    [showOptional]="showOptional"
    [isRequired]="isRequired"
    [rows]="rows"
    [maxLength]="maxLength"
    [minLength]="minLength"
    [markUnTouched]="markUnTouched"
    [theme]="theme"
    [style]="style"
    [bgColor]="bgColor"
    (childValue)="value"
    [(ngModel)]="value"
  ></app-form-control-textarea>
</ng-container>

<ng-template #disabledInput>
  <app-input-textarea-disabled
    [hasBorder]="hasBorder"
    [isGrey]="isGrey"
    [label]="label"
    [theme]="theme"
    [style]="style"
    [value]="showDisabledValue ? value : ''"
  ></app-input-textarea-disabled>
</ng-template>
